import type { FleetPercentageEuro, FleetPercentageFuel } from "src/types";

type SummableFuel = Pick<FleetPercentageFuel, "fuelPercentage">;
type SummableEuro = Pick<FleetPercentageEuro, "euroPercentage">;

function hasFuelPercentage(obj: unknown): obj is SummableFuel {
	return (
		obj != null &&
		typeof obj === "object" &&
		"fuelPercentage" in obj &&
		typeof (obj as SummableFuel).fuelPercentage === "number"
	);
}

function hasEuroPercentage(obj: unknown): obj is SummableEuro {
	return (
		obj != null &&
		typeof obj === "object" &&
		"euroPercentage" in obj &&
		typeof (obj as SummableEuro).euroPercentage === "number"
	);
}

export function sumFuelPercentages(fuels: SummableFuel[] | unknown): number {
	if (!Array.isArray(fuels)) return 0;
	return fuels.reduce(
		(a, f) => a + (hasFuelPercentage(f) ? f.fuelPercentage : 0),
		0,
	);
}

export function sumEuroPercentages(euros: SummableEuro[] | unknown): number {
	if (!Array.isArray(euros)) return 0;
	return euros.reduce(
		(a, e) => a + (hasEuroPercentage(e) ? e.euroPercentage : 0),
		0,
	);
}

export function clampPercentFromInput(raw: unknown) {
	if (raw === "" || raw === null || raw === undefined) return 0;
	const parsed = typeof raw === "number" ? raw : Number(raw);
	if (!Number.isFinite(parsed)) return 0;
	return Math.min(100, Math.max(0, parsed));
}

export function clampIntegerPercentFromInput(raw: unknown) {
	return Math.trunc(clampPercentFromInput(raw));
}

export function hasFuelLabels(
	p: unknown,
): p is { categoryTranslation?: string; fuelTranslation?: string } {
	if (p === null || typeof p !== "object") return false;
	const o = p as Record<string, unknown>;
	return (
		(o.categoryTranslation === undefined ||
			typeof o.categoryTranslation === "string") &&
		(o.fuelTranslation === undefined || typeof o.fuelTranslation === "string")
	);
}

export function hasCategoryLabel(
	p: unknown,
): p is { categoryTranslation?: string } {
	if (p === null || typeof p !== "object") return false;
	const o = p as Record<string, unknown>;
	return (
		o.categoryTranslation === undefined ||
		typeof o.categoryTranslation === "string"
	);
}
